import React from "react";
import { View } from "react-native"
import { Label,Form,RateBox} from "../../../../components/SharedComponents";
import localize from "../../../../shared/localize";


export default function InviteFamilyMember({ invite, inviteError, role_type, familyName, onChangeText }) {

    let title = localize.formatString(localize.Invite_trusted_child_to_your, familyName);
    if (role_type === 1) title = localize.formatString(localize.Invite_trusted_adults_like_parents, familyName);
    else if (role_type === 2) title = localize.formatString(localize.Invite_trusted_Teacher_like, familyName);

    return (
        <View>
            <View style={{ alignItems: "flex-end", marginTop: 40, marginBottom: -10 }}>
                <RateBox rate={20} />
            </View>
            <Form.TextInput
                title={localize.email_address}
                onChangeText={onChangeText}
                value={invite}
                multiline={true}
                numberOfLines={5}
                error={inviteError}
                style={{ minHeight: 150, textAlignVertical: "top", padding: 10 }}
            />
            <Label.PrimarySubtitle style={{ fontStyle: "italic", marginVertical: 30 }}>
                {localize.Separate_each_email_with_a_comma}
            </Label.PrimarySubtitle>
        </View>
    )
}